
import { Notyf } from 'notyf';
import 'notyf/notyf.min.css'; // for React, Vue and Svelte


window.notyf = new Notyf({
    duration: 3000,
    position: {
        x: 'right',
        y: 'top',
    },
    dismissible: true
});
const flashMessages = JSON.parse(document.getElementById('flash-messages').value);
if (flashMessages.success) {
    window.notyf.success(flashMessages.success);
}
if (flashMessages.notice) {
    window.notyf.success(flashMessages.notice);
}
if (flashMessages.error) {
    window.notyf.error({
        message: flashMessages.error,
        duration: 10000
    });
}
